import { Injectable } from '@angular/core';
import { Config } from './config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AnomalyReasonsResponse, AutoScrubSummary, AutoScrubSummaryReportArgs } from '../models/auto-scrub-summary';
import { AutoDetectDetectCountArgs } from '../models/auto-scrub-details';
import { AnomaliesCount } from '../models/AnomaliesCount';
import { map } from 'rxjs/operators';

@Injectable()
export class AutoScrubSummaryService {
    public autoScrubSummaryDetails: AutoScrubSummary[];

    /*
     * @autoScrubSummaryDetailsSorted varibale to store current sorted data of table.
     */
    public autoScrubSummaryDetailsSorted = new Array<AutoScrubSummary>();

    constructor(public http: HttpClient) {}

    public getAutoScrubSummary(params: AutoScrubSummaryReportArgs) {
        let httpParams: HttpParams = new HttpParams();

        Object.keys(params).forEach(function (key) {
            if (key !== 'locationGroupID') {
                httpParams = httpParams.append(key, params[key]);
            }
        });

        if (params.locationGroupID > 0) {
            httpParams = httpParams.append('LocationGroupID', params.locationGroupID.toString());
        }

        return this.http.get<AutoScrubSummary[]>(Config.urls.anomaliesSummary, { params: httpParams });
    }

    public postAnomaliesRefresh(customerId: number) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.append('cid', customerId.toString());
        return this.http.post<string>(Config.urls.anomaliesReferesh, { params: httpParams });
    }

    // get the tile count for auto-detect.
    public getAutoDetectCount(params: AutoDetectDetectCountArgs) {
        let httpParams: HttpParams = new HttpParams();

        Object.keys(params).forEach(function (key) {
            httpParams = httpParams.append(key, params[key]);
        });

        return this.http.get<AnomaliesCount>(Config.urls.anomaliesCount, { params: httpParams }).pipe(
            map((res) => {
                const anomaliesCount: AnomaliesCount = {
                    requireReview: res.requireReview || 0,
                    suggestedReview: res.suggestedReview || 0,
                };
                return anomaliesCount;
            }),
        );
    }

    public getAnomaliesReasons() {
        return this.http.get<AnomalyReasonsResponse>(Config.serviceUrl + Config.urls.reasonedAnomalies).pipe(
            map((response: AnomalyReasonsResponse) => {
                return response.payload;
            }),
        );
    }
}
